module.exports = __webpack_public_path__ + "static/media/part-3.4fdb12cb.jpg";